var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container scoped-salary-rules"
  }, [_c('div', {
    staticClass: "background-white box-shadow-small border-radius"
  }, [_c('el-breadcrumb', {
    staticClass: "mt-10 mb-25",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'paymentRules'
      }
    }
  }, [_vm._v("定薪规则管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("编辑规则")])], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "90px",
      "model": _vm.ruleForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "规则名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "medium",
      "maxlength": 20,
      "placeholder": "请输入规则名称"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "是否启用:"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.state),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "state", $$v)
      },
      expression: "ruleForm.state"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("停用")])], 1), _vm._v(" "), _c('span', {
    staticClass: "level-tip"
  }, [_vm._v("（停用后将不能使用该定薪规则，但不影响历史数据）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "说明文档:"
    }
  }, [_c('el-upload', {
    staticClass: "upload-desc",
    attrs: {
      "multiple": false,
      "action": _vm.action,
      "on-preview": _vm.handlePreview,
      "accept": "application/pdf",
      "on-success": _vm.handleFileSuccess,
      "on-remove": _vm.handleFileRemove,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "file-upload-tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("（只限pdf格式）")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "定级详情:"
    }
  }, [_vm._l((_vm.paymentConfigs), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rule-row mb-15"
    }, [_c('div', {
      staticClass: "el-table el-table--fit el-table--border el-table--enable-row-transition",
      staticStyle: {
        "width": "602px"
      }
    }, [_c('table', {
      staticClass: "el-table__body"
    }, [_c('tr', {
      staticClass: "el-table__row"
    }, [_c('td', {
      staticClass: "is-center",
      attrs: {
        "width": "50"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v("定级")])]), _vm._v(" "), _c('td', {
      staticClass: "is-center",
      attrs: {
        "width": "400"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('el-input', {
      attrs: {
        "size": "medium",
        "placeholder": "请输入定级名称"
      },
      model: {
        value: (item.secLevel),
        callback: function($$v) {
          _vm.$set(item, "secLevel", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.secLevel"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "is-center",
      attrs: {
        "width": "150"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.addInnerRow(item)
        }
      }
    }, [_vm._v("新增")]), _vm._v(" "), (_vm.paymentConfigs.length > 1) ? _c('el-button', {
      staticStyle: {
        "color": "#ff4949"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.paymentConfigs.splice(index, 1)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('el-table', {
      staticClass: "rule-salary",
      staticStyle: {
        "width": "602px"
      },
      attrs: {
        "data": item.paymentList,
        "border": "",
        "align": "center"
      }
    }, [_c('el-table-column', {
      attrs: {
        "header-align": "center",
        "align": "center",
        "width": "50",
        "type": "index"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "header-align": "center",
        "align": "center",
        "width": "200",
        "label": "定薪",
        "prop": "paymentLevel"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "medium"
            },
            model: {
              value: (scope.row.paymentLevel),
              callback: function($$v) {
                _vm.$set(scope.row, "paymentLevel", (typeof $$v === 'string' ? $$v.trim() : $$v))
              },
              expression: "scope.row.paymentLevel"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "header-align": "center",
        "align": "center",
        "width": "200",
        "label": "offer标准",
        "prop": "paymentMonth"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "medium",
              "maxlength": "10"
            },
            model: {
              value: (scope.row.paymentMonth),
              callback: function($$v) {
                _vm.$set(scope.row, "paymentMonth", (typeof $$v === 'string' ? $$v.trim() : $$v))
              },
              expression: "scope.row.paymentMonth"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "header-align": "center",
        "align": "center",
        "width": "150",
        "label": "操作"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.paymentList.length > 1) ? _c('el-button', {
            staticStyle: {
              "color": "#ff4949"
            },
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return item.paymentList.splice(scope.$index, 1)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()]
        }
      }], null, true)
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [_c('el-button', {
    attrs: {
      "type": "default",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addLevelBlock
    }
  }, [_vm._v("添加定级")]), (_vm.paymentConfigs.length) ? _c('span', {
    staticClass: "level-tip"
  }, [_vm._v("（当前共" + _vm._s(_vm.paymentConfigs.length) + "个定级）")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "handler-btns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$back({
          name: 'paymentRules'
        })
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d0a7878"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/salary/salayRuleDetail.vue
// module id = null
// module chunks = 